export default [
  {
    name: 'ClickByDynamicConfigs',
    path: '/click-by-dynamic-configs',
    component: () => import('./pages/ClickByDynamicConfigs'),
    meta: {
      ability: [
        {
          resource: 'click-by-dynamic-configs',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add ClickByDynamicConfig',
    path: '/click-by-dynamic-configs/add',
    component: () => import('./pages/ClickByDynamicConfigsDetails'),
    meta: {
      ability: [
        {
          resource: 'click-by-dynamic-configs',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit ClickByDynamicConfig',
    path: '/click-by-dynamic-configs/edit/:id',
    component: () => import('./pages/ClickByDynamicConfigsDetails'),
    meta: {
      ability: [
        {
          resource: 'click-by-dynamic-configs/:id',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
